import { render } from "./LayoutAuth.vue?vue&type=template&id=9d7bed50"
import script from "./LayoutAuth.vue?vue&type=script&lang=js"
export * from "./LayoutAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__